const usedFlagMap = {
  1015: "googleAnalytics",
  1016: "onlineBanking",
  1017: "oneTimePayment",
  1028: "commerceCareWeb",
  999: "aprDate"
};

/**
 *
 * @param [Array] featureFlagsArray
 * @returns {*}
 */
const mapFeatureFlags = featureFlagsArray => {
  return featureFlagsArray.reduce((map, flag) => {
    map[flag.id] = flag;
    return map;
  }, {});
};

/**
 *
 * @param featureFlagsArray
 * @returns {*}
 */
const filteredMapFeatureFlags = featureFlagsArray => {
  return featureFlagsArray.reduce((map, flag) => {
    if (flag.id in usedFlagMap) {
      map[usedFlagMap[flag.id]] = flag;
    }
    return map;
  }, {});
};

module.exports = {
  idMap: usedFlagMap,
  mapFeatureFlags: mapFeatureFlags,
  filteredMapFeatureFlags: filteredMapFeatureFlags
};
